import { instance } from "api/apiBase";
import {
  CombinedIncomeVerificationSchema,
  FieldDisplaySetting,
  IncomeType,
  SupervisorDetails
} from "shared/types";
import { getByPath, normalizeFile, normalizeFilename } from "shared/utils";

export const uploadFilesToS3 = async (files: File[]) => {
  return Promise.all(
    files.map(async (file) => {
      const queryParams = new URLSearchParams({
        filename: normalizeFilename(file.name),
        type: file.type
      }).toString();

      const { data: presignData } = await instance.get<{ url: string }>(
        `/portal/v1/boom_screen/assets/presign?${queryParams}`
      );

      const s3Response = await fetch(presignData.url, {
        method: "PUT",
        body: normalizeFile(file),
        mode: "cors"
      });

      const uploadedUrl = s3Response.url.split("?")[0];

      return uploadedUrl;
    })
  );
};

export const shouldSkipSupervisorDetails = (
  verificationSchema: CombinedIncomeVerificationSchema | undefined,
  incomeType: IncomeType | null | undefined
): boolean => {
  const supervisorFields = getByPath(verificationSchema, [
    incomeType || IncomeType.Employment,
    "fields",
    "supervisor"
  ]) as SupervisorDetails | undefined;

  const fieldSettings = Object.values(supervisorFields || {});
  if (!fieldSettings.length) return false;

  return fieldSettings.every(
    (setting) => setting === FieldDisplaySetting.Hidden
  );
};
